import { useMqttSubscription } from '../../../mqtt/hooks/useMqttSubscription';

export function useUserInboxSubscription({
  loggedInUserId,
  onNotificationReceive,
  topics,
}: {
  loggedInUserId?: string;
  onNotificationReceive: (payload: Buffer) => void;
  topics?: string[];
}) {
  useMqttSubscription(topics ?? `INBOX_U_${loggedInUserId}`, {
    onMessage: onNotificationReceive,
  });
}
